import React, { useEffect, useState } from "react";
import {
    DKLabel,
    DKButton,
    DKInput,
    INPUT_VIEW_DIRECTION,
    DKCheckMark,
    removeLoader,
    showLoader,
    showToast,
    TOAST_TYPE,
} from "deskera-ui-library";
import {
    INPUT_TYPE,
    ORGANIZATION_IDS,
    EMPLOYEE_TYPES,
    PAYMENT_CODES,
    SECTOR_TYPES,
    PROFILE_STAGES_CONSTANT,
} from "../constants/Constant";
import Utility, { deepClone } from "../utility/Utility";
import EmployeeListService from "../services/EmployeeListService";
import { getTenantCountryCode } from "../managers/common/CommonUtil";
import CompanyDetailService from "../services/CompanyDetailService";
import ProfileSetupService from "../services/ProfileSetup-service";
import TenantManager from "../managers/TenantManager";

const AddCpfAccount = (props) => {
    const formFields = [
        {
            columnCode: "name",
            name: "Add New CPF Account",
            isRequired: true,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.TEXT,
        },
        {
            columnCode: "submissionNumber",
            name: "CPF Submission Number",
            isRequired: true,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.TEXT,
        },
        {
            columnCode: "organizationId",
            name: "Organization ID",
            isRequired: true,
            hasError: false,
            options: ORGANIZATION_IDS,
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.DROPDOWN,
        },
        {
            columnCode: "organizationIdNumber",
            name: "Organisation ID Number",
            isRequired: true,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.TEXT,
        },
        {
            columnCode: "employeeType",
            name: "Employee Type",
            isRequired: true,
            hasError: false,
            options: EMPLOYEE_TYPES,
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.DROPDOWN,
        },
        {
            columnCode: "adviseCode",
            name: "Advise Code",
            isRequired: true,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: true,
            tooltipMsg: "value should be between 1-99",
            type: INPUT_TYPE.NUMBER,
            hasMin: true,
            hasMax: true,
            minValue: 1,
            maxValue: 99,
        },
        {
            columnCode: "paymentCode",
            name: "Payment Code",
            isRequired: true,
            hasError: false,
            options: PAYMENT_CODES,
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.DROPDOWN,
        },
        {
            columnCode: "serialNumber",
            name: "Serial Number",
            isRequired: true,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: true,
            tooltipMsg: "value should be between 1-99",
            type: INPUT_TYPE.NUMBER,
            hasMin: true,
            hasMax: true,
            minValue: 1,
            maxValue: 99,
        },
        {
            columnCode: "sectorType",
            name: "Sector Type",
            isRequired: false,
            hasError: false,
            options: SECTOR_TYPES,
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.DROPDOWN,
        },
        {
            columnCode: "includeSkillDevelopmentLevy",
            name: "Include skill development levy",
            isRequired: false,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.CHECKBOX,
        },
        {
            columnCode: "includeForeignWorkerLevy",
            name: "Include foreign worker levy",
            isRequired: false,
            hasError: false,
            options: [],
            errMsg: "",
            hasTooltip: "",
            tooltipMsg: "",
            type: INPUT_TYPE.CHECKBOX,
        },
    ];

    const [cpfFormFields, setFormFields] = useState(formFields);
    const [defaultValues, setDefaultValues] = useState({
        includeSkillLevy: false,
        includeForeignLevy: false
    });
    const [accountDetails, setAccountDetails] = useState(props.details)

    useEffect(() => {
        if (props.isEdit && !Utility.isEmptyObject(props.details)) {
            updateDefaultValues();
        }
    }, []);

    const updateDefaultValues = () => {
        const complianceDetails = accountDetails?.compliance;
        const details = deepClone(defaultValues);
        details["name"] = complianceDetails["name"];
        details["submissionNumber"] = complianceDetails["submissionNumber"];
        details["organizationId"] = EmployeeListService.getValueObjectFromDropdown(
            complianceDetails["organizationId"],
            ORGANIZATION_IDS,
            "id"
        );
        details["organizationIdNumber"] = complianceDetails["organizationIdNumber"];
        details["employeeType"] = EmployeeListService.getValueObjectFromDropdown(
            complianceDetails["employeeType"],
            EMPLOYEE_TYPES,
            "id"
        );
        details["adviseCode"] = complianceDetails["adviseCode"];
        details["paymentCode"] = EmployeeListService.getValueObjectFromDropdown(
            complianceDetails["paymentCode"],
            PAYMENT_CODES,
            "id"
        );
        details["serialNumber"] = complianceDetails["serialNumber"];
        details["sectorType"] = EmployeeListService.getValueObjectFromDropdown(
            complianceDetails["sectorType"],
            SECTOR_TYPES,
            "id"
        );
        details["includeSkillDevelopmentLevy"] =
            complianceDetails["includeSkillDevelopmentLevy"];
        details["includeForeignWorkerLevy"] =
            complianceDetails["includeForeignWorkerLevy"];
        details["accountId"] = accountDetails?.accountId;
        setDefaultValues(details);
    }

    const onSave = () => {
        if (isInvalid()) {
            return;
        }
        const parameters = getAccountObject();
        if (!props.isEdit) {
            saveDetails(parameters);
        } else {
            updateDetails(parameters);
        }
    };

    const getAccountObject = () => {
        const params = {
            countryCode: getTenantCountryCode(),
            accountType: "CPF",
            compliance: {
                "@type": "type.googleapis.com/v1.CPFAccount",
                countryCode: getTenantCountryCode(),
                name: defaultValues["name"],
                submissionNumber: defaultValues["submissionNumber"],
                organizationId: defaultValues["organizationId"]?.id,
                organizationIdNumber: defaultValues["organizationIdNumber"],
                employeeType: defaultValues["employeeType"]?.id,
                adviseCode: !Utility.isEmpty(defaultValues["adviseCode"])
                    ? parseInt(defaultValues["adviseCode"])
                    : "",
                paymentCode: defaultValues["paymentCode"]?.id,
                serialNumber: !Utility.isEmpty(defaultValues["serialNumber"])
                    ? parseInt(defaultValues["serialNumber"])
                    : "",
                sectorType: defaultValues["sectorType"]?.id,
                includeSkillDevelopmentLevy:
                    defaultValues["includeSkillDevelopmentLevy"],
                includeForeignWorkerLevy: defaultValues["includeForeignWorkerLevy"],
            },
        };
        if (props.isEdit) {
            params["accountId"] = defaultValues["accountId"];
        }
        return params;
    }

    const saveDetails = (params) => {
        showLoader("Adding... Please wait");
        CompanyDetailService.addCPFAccount(params).then(
            (response) => {
                showToast(
                    "CPF Account added successfully",
                    TOAST_TYPE.SUCCESS
                );
                removeLoader();
                props.onClose(true);

                ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.CPF_DETAILS).then((res) => {
                    TenantManager.setProfileData(res["profileStages"]);
                });
            },
            (error) => {
                showToast(
                    "Something went wrong.",
                    TOAST_TYPE.FAILURE
                );
                removeLoader();
                props.onClose(false);
            }
        );
    }

    const updateDetails = (params) => {
        showLoader("Updating... Please wait");
        CompanyDetailService.updateCPFAccount(params).then(
            (response) => {
                showToast("CPF Account updated successfully", TOAST_TYPE.SUCCESS);
                removeLoader();
                props.onClose(true);
            },
            (error) => {
                showToast(
                    "Something went wrong.",
                    TOAST_TYPE.FAILURE
                );
                removeLoader();
                props.onClose(false);
            }
        );
    }

    const isInvalid = () => {
        const alteredConfig = [];
        const formFieldsCopy = deepClone(cpfFormFields);
        for (let i = 0; i < formFieldsCopy.length; i++) {
            let field = formFieldsCopy[i];
            if (
                (field.isRequired &&
                    Utility.isEmpty(defaultValues[field.columnCode])) ||
                field.hasError
            ) {
                field.hasError = true;
                alteredConfig.push(field);
            }
        }
        if (alteredConfig.length > 0) {
            const formfields = EmployeeListService.getAlteredConfigDetails(
                formFieldsCopy,
                alteredConfig,
                false,
                {},
                {}
            );
            setFormFields(formfields);
        }
        return alteredConfig.length > 0;
    }

    const onCheckBoxClick = (field, index) => {
        const values = deepClone(defaultValues);
        values[field.columnCode] = !values[field.columnCode];
        setDefaultValues(values);
    }

    const onChange = (value, field, index) => {
        const formFieldsCopy = deepClone(cpfFormFields);
        const alteredConfig = [];
        switch (field.type) {
            case INPUT_TYPE.NUMBER:
                const intValue = parseInt(value);
                if (field.isRequired && Utility.isEmpty(intValue)) {
                    field.hasError = true;
                    field.errMsg = `Enter a valid ${field.name}`;
                } else if (
                    field.hasMin &&
                    intValue < field.minValue
                ) {
                    field.hasError = true;
                    field.errMsg = "Value should be between 1-99";
                } else if (
                    field.hasMax &&
                    intValue > field.maxValue
                ) {
                    field.hasError = true;
                    field.errMsg = "Value should be between 1-99";
                } else {
                    field.hasError = false;
                }
                break;
            default:
                if (field.isRequired && Utility.isEmpty(value)) {
                    field.hasError = true;
                    field.errMsg = `Enter a valid ${field.name}`;
                } else {
                    field.hasError = false;
                }
        }
        alteredConfig.push(field);
        defaultValues[field.columnCode] = value;
        const formfields = EmployeeListService.getAlteredConfigDetails(
            formFieldsCopy,
            alteredConfig,
            false,
            {},
            {}
        );
        setFormFields(formfields);
    }

    const getInputForm = () => {
        return cpfFormFields.map((field, index) => {
            return (
                <>
                    {field.type != INPUT_TYPE.CHECKBOX && (
                        <div className="column parent-width mb-l">
                            <DKInput
                                title={field.name}
                                type={field.type}
                                formatter={(obj) => {
                                    /** How to render a selected option in case of object **/
                                    return obj.name;
                                }}
                                value={defaultValues[field.columnCode]}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={field.isRequired}
                                canValidate={field.hasError}
                                errorMessage={field.errMsg}
                                validator={(value) => {
                                    return !field.hasError;
                                }}
                                onChange={(value) => {
                                    onChange(value, field, index)
                                }}
                                tooltip={{
                                    content: field.tooltipMsg,
                                    className: "warning-tooltip-prop",
                                }}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch:
                                        field.options && field.options.length > 6 ? true : false,
                                    searchableKey: "name",
                                    data: field.options,
                                    renderer: (index, obj) => {
                                        /** How to render value in Dropdown in case of object **/
                                        return <DKLabel text={`${obj.name}`} />;
                                    },
                                    onSelect: (index, obj) => {
                                        // onValueChange(obj, "Quarter");
                                    },
                                }}
                            />
                        </div>
                    )}
                    {field.type === INPUT_TYPE.CHECKBOX && (
                        <div
                            className="row mb-m"
                            key={field.columnCode}
                        >
                            <div
                                onClick={() => onCheckBoxClick(field, index)}
                            >
                                <DKCheckMark
                                    isSelected={defaultValues[field.columnCode]
                                    }
                                    color="bg-app"
                                />
                            </div>
                            <DKLabel className="ml-s" text={field.name} />

                        </div>
                    )}
                </>
            );
        });
    };

    const getHeader = () => {
        return (
            <div className="row justify-content-between p-h-m">
                <DKLabel
                    text={!props.isEdit ? "Add CPF Account" : "Edit CPF Account"}
                    className="fw-b fs-m"
                />
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            props.onClose(false);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className=" transparent-background-light">
            <div className="p-h-r pt-r pb-xl popup-window">
                <div className="popup-wrapper parent-width parent-height">
                    {getHeader()}
                    <div className="p-m">{getInputForm()}</div>
                </div>
            </div>
        </div>
    );
};

export default AddCpfAccount;
